import { Alert } from '@mui/material';

/**
 * Alerta de erro dinâmico (API, carregamento, etc.) — substitui o padrão
 * `{error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}` em 5 páginas.
 *
 * Renderiza nada quando `error` é falsy.
 *
 * @param {string|null} error - Mensagem de erro, ou null/undefined para não renderizar
 * @param {Object}      [sx]  - sx extra passado ao Alert (default inclui mb: 2)
 * @param {*}           props - demais props repassadas ao Alert
 *
 * @example
 * <ErrorAlert error={error} />
 * <ErrorAlert error={fetchError} sx={{ mt: 1 }} />
 */
export default function ErrorAlert({ error, sx, ...props }) {
  if (!error) return null;
  return (
    <Alert severity="error" sx={{ mb: 2, ...sx }} {...props}>
      {error}
    </Alert>
  );
}
